import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevicesDevicesDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getDevicesBasic(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_listDevicesBasic', item, options);
  }

  public getDeviceInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_getDeviceInfo', item, options);
  }

  public addDevice(context, lang, udid, token, centerInternalId, deviceName) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { token, centerInternalId, deviceName };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_registerDevice', item, options);
  }

  public addDeviceWithLicense(context, lang, udid, token, centerInternalId, deviceName, licenseInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { token, centerInternalId, deviceName, licenseInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/registerWithLicense', item, options);
  }

  public addIOT(context, lang, udid, centerInternalId, deviceType, brand, model, platform, ipAddress, deviceName, serialNumber, iotVersion, urlWebhook, properties) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, deviceType, brand, model, platform, ipAddress, deviceName, serialNumber, iotVersion, urlWebhook, properties };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/device/iot', item, options);
  }

  public addIOTWithLicense(context, lang, udid, centerInternalId, deviceType, brand, model, platform, ipAddress, deviceName, serialNumber, iotVersion, urlWebhook, properties, licenseInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalId, deviceType, brand, model, platform, ipAddress, deviceName, serialNumber, iotVersion, urlWebhook, properties, licenseInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/device/iotWithLicense', item, options);
  }

  public updateDevice(context, lang, udid, internalId, deviceName, deviceDescription, deviceNote, deviceLocation, centerInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, deviceName, deviceDescription, deviceNote, deviceLocation, centerInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_updateDevice', item, options);
  }

  public deleteDevice(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_deleteDevice', item, options);
  }

  public updateDeviceStatus(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_updateDeviceStatus', item, options);
  }

  public updateBrightness(context, lang, udid, internalId, pushValue) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, pushValue };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_pushDeviceForBrightness', item, options);
  }

  public updateVolume(context, lang, udid, internalId, pushValue) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, pushValue };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_pushDeviceForVolume', item, options);
  }

  public lock(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, pushValue: true };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_pushDeviceForLock', item, options);
  }

  public unlock(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, pushValue: true };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_pushDeviceForUnlock', item, options);
  }

  public takeScreenshot(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, pushValue: true };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_pushDeviceForScreenshot', item, options);
  }

  public requestUpdateDevice(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_pushDeviceForUpdate', item, options);
  }

  public updateDeviceOwnImage(context, lang, udid, internalId, imageRaw) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, imageRaw };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/ws_updateDeviceOwnImage', item, options);
  }

  public setMasterDevice(context, lang, udid, internalId, master) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, master };
    return this.http.put(this.BASE_URL + 'private/v2.0/deviceMaintenance/device/master', item, options);
  }

  public restartDevice(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/deviceMaintenance/pushDeviceForRestart', item, options);
  }

  public launchRemoteAccess(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post<{ status: string | number; data: { launchUrl?: string; url?: string } }>(
      this.BASE_URL + 'private/v2.0/deviceMaintenance/remoteAccess/launch', item, options
    );
  }

  public listOfPeripheralTypes(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/peripheralMaintenance/ws_listOfPerpheralTypes', item, options);
  }

  public getPeripheral(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/peripheralMaintenance/ws_getPeripheralDetails', item, options);
  }

  public savePeripheral(context, lang, udid, active, internalId, deviceInternalId, peripheralName, peripheralType, peripheralConnectionType, peripheralConnectionPort, vendorId, productId, comBaud, btName, btMac, btPassword, tcpIp) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, internalId, deviceInternalId, peripheralName, peripheralType, peripheralConnectionType, peripheralConnectionPort, vendorId, productId, comBaud, btName, btMac, btPassword, tcpIp };
    return this.http.post(this.BASE_URL + 'private/v2.0/peripheralMaintenance/ws_savePeripheral', item, options);
  }

  public updateStatusPeripheral(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/peripheralMaintenance/ws_updateStatusPeripheral', item, options);
  }

  public deletePeripheral(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/peripheralMaintenance/ws_deletePeripheral', item, options);
  }

  public getDevicesByStatus(context, lang, udid, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/devices/byStatus', options);
  }

  public getDevicesByType(context, lang, udid, centerInternalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { centerInternalIds };
    options['params'] = item;
    return this.http.get(this.BASE_URL + 'private/v2.0/dashboard/statistics/devices/byType', options);
  }

  public updateDeviceLicense(context, lang, udid, deviceInternalId, licenseInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { deviceInternalId, licenseInternalId };
    return this.http.put(this.BASE_URL + 'private/v2.0/deviceMaintenance/device/license', item, options);
  }
}
